import { createVar } from '@vanilla-extract/css';
import { recipe } from '@vanilla-extract/recipes';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

const size = createVar('delivery-mode-popover-circle-size');
const innerColor = createVar('delivery-mode-popover-circle-inner-color');
const borderColor = createVar('delivery-mode-popover-circle-border-color');

export const circle = recipe(
  {
    base: {
      width: size,
      height: size,
      borderRadius: themeVars.radius.full,
      border: `${themeVars.space['050']} solid ${borderColor}`,
      backgroundColor: innerColor,

      vars: {
        [size]: themeVars.space['200'],
      },
    },

    variants: {
      variant: {
        success: {
          vars: {
            [innerColor]: themeVars.color['scope-success-mark'],
            [borderColor]: themeVars.color['scope-success-subtle-border'],
          },
        },
        caution: {
          vars: {
            [innerColor]: themeVars.color['scope-caution-mark'],
            [borderColor]: themeVars.color['scope-caution-subtle-border'],
          },
        },
        critical: {
          vars: {
            [innerColor]: themeVars.color['scope-critical-mark'],
            [borderColor]: themeVars.color['scope-critical-subtle-border'],
          },
        },
      },
    },
  },
  'delivery-mode-popover-circle',
);
